import { Injectable } from '@angular/core';
import { GoogleModuleOptions } from '@ng-maps/google';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GenericOldService } from './generic-old.service';

@Injectable({ providedIn: 'root' })
export class GoogleService implements GoogleModuleOptions {
  apiKey: string | undefined;
  libraries = ['places'];

  constructor(private resourceService: GenericOldService<string>) {}

  load(): Observable<string> {
    return this.resourceService.get('configs/google').pipe(
      tap(key => {
        const node = document.createElement('script');
        node.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&loading=async`;
        node.type = 'text/javascript';
        node.async = true;
        document.getElementsByTagName('head')[0].appendChild(node);
        this.apiKey = key;
      }),
    );
  }
}
